import { useTranslation } from 'react-i18next';

import { SUPPORTED_LOCALES } from '@shared/constants.js';

const labels = { en: 'EN', ar: 'العربية', fr: 'FR' };

export function LangSwitcher() {
  const { i18n } = useTranslation();

  function change(e) {
    const lng = e.target.value;
    i18n.changeLanguage(lng);
    localStorage.setItem('locale', lng);
  }

  return (
    <label className="flex items-center gap-2 text-sm text-slate-600">
      <span className="sr-only">Language</span>
      <select
        value={i18n.language}
        onChange={change}
        className="rounded-md border border-slate-300 bg-white px-2 py-1 text-sm focus:border-brand-600 focus:outline-none focus:ring-2 focus:ring-brand-600/30"
      >
        {SUPPORTED_LOCALES.map((lng) => (
          <option key={lng} value={lng}>
            {labels[lng] || lng}
          </option>
        ))}
      </select>
    </label>
  );
}
